import { MarkdownEditor } from "@components/markdown_editor/markdown_editor";
import { isNil } from "@services/typed_helpers";
import { useField } from "formik";
import React, { type FC, type ReactNode } from "react";

import { FormInputLayout } from "./form_input_layout";

type MarkdownFieldProps = {
  helpElement?: ReactNode;
  label: string;
  name: string;
};

const DEFAULT_MARKDOWN_HELP = (
  <>
    We use markdown.
    <a
      href="http://daringfireball.net/projects/markdown/basics"
      target="_blank"
    >
      {" "}
      Read the guide.
    </a>
    <br></br>
    Note: the preview mode may not reflect <strong>exactly</strong> what it will
    look like on the site but trust that it'll be close :D{" "}
  </>
);

const MarkdownField: FC<MarkdownFieldProps> = ({
  helpElement,
  label,
  name,
}) => {
  const [_field, meta, helpers] = useField(name);

  const handleChange = (value?: string) => {
    if (isNil(value)) {
      value = "";
    }
    helpers.setValue(value);
    helpers.setTouched(true);
  };

  const fieldElement = (
    <MarkdownEditor handleChange={handleChange} value={meta.initialValue} />
  );

  const props = {
    label,
    name,
    helpElement: helpElement ?? DEFAULT_MARKDOWN_HELP,
    fieldElement,
  };
  return <FormInputLayout {...props}></FormInputLayout>;
};

export { MarkdownField };
